var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useService } from '@tenderd/track-web-utils';
import { useEffect, useState } from 'react';
import { useGroupService } from '../../../../providers/GroupServiceProvider';
import { useGroupGeofencePageContext } from '../../GroupGeofencePage.context';
var useGeofenceList = function () {
    var _a = __read(useState(1), 2), page = _a[0], setPage = _a[1];
    var _b = useGroupGeofencePageContext(), geofences = _b.geofences, setGeofences = _b.setGeofences, searchGeofence = _b.searchGeofence;
    var service = useService();
    var group = useGroupService().group;
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var getGeoFences = function () {
        setLoading(true);
        service.server
            .getGroupSubgroupsGeofences(group.id, page, 10, searchGeofence)
            .then(function (res) {
            setGeofences(function (prev) { return ({
                metaData: res.metaData,
                data: __spreadArray(__spreadArray([], __read(prev.data), false), __read(res.data), false).filter(function (item, index, self) {
                    return index === self.findIndex(function (t) { return t._id === item._id; });
                }),
            }); });
        })
            .finally(function () { return setLoading(false); });
    };
    useEffect(function () {
        setGeofences({
            metaData: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                itemsPerPage: 10,
            },
            data: [],
        });
        setPage(1);
    }, [searchGeofence]);
    useEffect(function () {
        getGeoFences();
    }, [page, searchGeofence]);
    var loadMoreData = function () {
        if (geofences.metaData.totalPages > page)
            setPage(page + 1);
    };
    return { loadMoreData: loadMoreData, page: page, loading: loading, geofences: geofences };
};
export default useGeofenceList;
